import axios from 'axios';

const create = data => axios.post('/cotacoes-fretes', data);
const update = (id, data) => axios.put(`/cotacoes-fretes/${id}`, data);

const getCotacoes = params => axios.get('/cotacoes-fretes', {
  params,
});

const getSolicitacoes = idCotacao => axios.get(`/cotacoes-fretes/${idCotacao}/solicitacoes`);

const getCotacao = id => axios.get(`/cotacoes-fretes/${id}`);
const updateIdentifier = (id, cotacao) => axios.put(`/cotacoes-fretes/${id}/identifier`, cotacao);
const cancelar = (id, data) => axios.put(`/cotacoes-fretes/${id}/cancelar`, data);

const addTransportador = (idCotacao, idTransportador) => axios.put(`/cotacoes-fretes/${idCotacao}/transportadores/${idTransportador}`, {});

export default {
  create,
  update,
  getCotacoes,
  getSolicitacoes,
  getCotacao,
  updateIdentifier,
  cancelar,
  addTransportador,
};
